'use client'

import { BuilderBlocks } from '@builder.io/react'
import uniqueId from 'lodash/uniqueId'
import Image from 'next/image'

import { cn } from '@src/utils/tailwind'

import { expertGridDefaults } from './ExpertGrid.defaults'
import { type ExpertGridProps } from './ExpertGrid.props'

export const ExpertGrid = (props: ExpertGridProps = expertGridDefaults) => {
  const {
    backgroundColor,
    columnsDesktop,
    columnsMobile,
    imageAlt,
    experts,
    heading,
    imageSrcDesktop,
    imageRightDesktop,
    imageScaleDesktop,
    imageSrcMobile,
    subheading,
    children,
    childrenPositionDesktop,
  } = props

  const renderExpertGrid = () => {
    return (
      <div
        // eslint-disable-next-line tailwindcss/no-custom-classname
        className={cn(
          'grid w-fit shrink-0 place-items-center gap-x-2 gap-y-7 lg:place-items-start lg:gap-8',
          `lg:grid-cols-${columnsDesktop} grid-cols-${columnsMobile}`
        )}
      >
        {experts?.map((expert) => (
          <div key={uniqueId()} className="w-full max-w-[168px] text-body-md">
            <Image
              src={expert.imageSrc ?? ''}
              alt={expert.imageAlt ?? ''}
              sizes="100vw"
              width={0}
              height={0}
              className="mb-3"
              style={{
                width: '100%',
                height: 'auto',
              }}
            />
            {expert?.name && (
              <h6 className="mb-2 font-medium" dangerouslySetInnerHTML={{ __html: expert?.name }} />
            )}
            {expert?.description && <p dangerouslySetInnerHTML={{ __html: expert?.description }} />}
          </div>
        ))}
      </div>
    )
  }

  return (
    <div
      className=" relative grid grid-cols-1 rounded-[28px] text-bodi-black-text lg:grid-cols-12"
      style={{
        backgroundColor,
      }}
    >
      <div className="col-span-6 px-6 py-9 lg:p-16 xl:col-span-8">
        <div className="mb-6 max-w-xl">
          <h4
            className="text-heading-display-2 mb-4 lg:mb-6"
            dangerouslySetInnerHTML={{ __html: heading ?? '' }}
          ></h4>
          <p className="text-body-base" dangerouslySetInnerHTML={{ __html: subheading ?? '' }}></p>
        </div>
        <Image
          src={imageSrcMobile ?? ''}
          alt={imageAlt ?? ''}
          sizes="100vw"
          width={0}
          height={0}
          className="mx-auto mt-8 mb-12 max-w-sm lg:hidden"
          style={{
            width: '100%',
            height: 'auto',
          }}
        />

        <div
          className={cn('flex flex-col lg:flex-row', {
            'lg:flex-col': childrenPositionDesktop === 'bottom',
          })}
        >
          {renderExpertGrid()}
          {children && (
            <BuilderBlocks
              parentElementId={props?.builderBlock?.id}
              dataPath={`component.options.children`}
              blocks={props?.children}
            />
          )}
        </div>
      </div>
      {imageSrcDesktop && (
        <div className="relative z-10 col-span-6 h-full xl:col-span-4">
          <Image
            alt={imageAlt ?? ''}
            src={imageSrcDesktop}
            sizes="100vw"
            width={0}
            height={0}
            className="absolute inset-0 hidden origin-bottom-right object-cover lg:block"
            style={{
              width: 'auto',
              height: '100%',
              right: imageRightDesktop,
              scale: imageScaleDesktop,
            }}
          />
        </div>
      )}
    </div>
  )
}
